import {EXPERIMENTAL_TABLE_SHORTCUTS, TABLE_SHORTCUTS} from 'notebook/tables/TableShortcuts';
import {ShortcutDescription} from 'util/Keyboard';

export const TABLE_SHORTCUT_DESCRIPTIONS: Array<ShortcutDescription> = TABLE_SHORTCUTS.flatMap(
  (shortcut) => shortcut.descriptionsForModal
);

export const EXPERIMENTAL_TABLE_SHORTCUT_DESCRIPTIONS: Array<ShortcutDescription> =
  EXPERIMENTAL_TABLE_SHORTCUTS.flatMap((shortcut) => shortcut.descriptionsForModal);

export const NOTEBOOK_SHORTCUTS: Array<ShortcutDescription> = [
  {
    description: 'Copy',
    shortcuts: [{normalizedShortcutText: 'Ctrl + C'}],
  },
  {
    description: 'Cut',
    shortcuts: [{normalizedShortcutText: 'Ctrl + X'}],
  },
  {
    description: 'Paste',
    shortcuts: [{normalizedShortcutText: 'Ctrl + V'}],
  },
  {
    description: 'Undo',
    shortcuts: [{normalizedShortcutText: 'Ctrl + Z'}],
  },
  {
    description: 'Redo',
    shortcuts: [{normalizedShortcutText: 'Ctrl + Shift + Z'}, {normalizedShortcutText: 'Ctrl + Y'}],
  },
];

export const FORMATTING_SHORTCUTS: Array<ShortcutDescription> = [
  {
    description: 'Bold',
    shortcuts: [{normalizedShortcutText: 'Ctrl + B'}],
  },
  {
    description: 'Italic',
    shortcuts: [{normalizedShortcutText: 'Ctrl + I'}],
  },
  {
    description: 'Underline',
    shortcuts: [{normalizedShortcutText: 'Ctrl + U'}],
  },
  {
    description: 'Strikethrough',
    shortcuts: [{normalizedShortcutText: 'Ctrl + Shift + X'}],
  },
  {
    description: 'Link',
    shortcuts: [{normalizedShortcutText: 'Ctrl + K'}],
  },
  {
    description: 'Monospace',
    shortcuts: [{normalizedShortcutText: 'Ctrl + Shift + K'}],
  },
  {
    description: 'Symbol',
    shortcuts: [{normalizedShortcutText: 'Ctrl + ;'}],
  },
  {
    description: 'Superscript',
    shortcuts: [{normalizedShortcutText: 'Ctrl + .'}],
  },
  {
    description: 'Subscript',
    shortcuts: [{normalizedShortcutText: 'Ctrl + Shift + .'}],
  },
  {
    description: 'Insert section/day',
    shortcuts: [{normalizedShortcutText: 'Ctrl + \\'}],
  },
  {
    description: 'Cycle header style',
    shortcuts: [{normalizedShortcutText: 'Ctrl + `', skipOsTranslation: true}],
  },
];

export const WORKSPACE_SHORTCUTS: Array<ShortcutDescription> = [
  {
    description: 'Switch to next tab',
    shortcuts: [{normalizedShortcutText: 'Ctrl + Shift + 0'}],
  },
  {
    description: 'Switch to previous tab',
    shortcuts: [{normalizedShortcutText: 'Ctrl + Shift + 9'}],
  },
  {
    description: 'Show keyboard shortcuts',
    shortcuts: [{normalizedShortcutText: 'Ctrl + ?'}],
  },
];
